import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchSameCategoryShoppings } from '@/actions/shopping';
import useShopping from '@/hooks/useShopping';
import useShoppingList from '@/hooks/useShoppingList';

export default function useShoppingDetail() {
  const dispatch = useDispatch();
  const [shopping, error] = useShopping();
  const shoppingList = useShoppingList();
  useEffect(() => {
    shopping &&
      dispatch(
        fetchSameCategoryShoppings({
          shoppingCat: shopping.fields.cat,
          shoppingId: shopping.fields.id
        })
      );
  }, [dispatch, shopping]);

  return [shopping, shoppingList, error.status] as const;
}
